import RegistrationLegalModal from "./registration-legal-modal";

export default RegistrationLegalModal;